import type { SVGProps } from 'react';

export const CaretRightIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.7064 11.2932L9.37311 2.95987C8.98244 2.5692 8.34911 2.5692 7.95845 2.95987C7.56778 3.35054 7.56778 3.98387 7.95845 4.37453L15.5851 12.0012L7.95845 19.6278C7.56778 20.0185 7.56778 20.6518 7.95845 21.0425C8.15311 21.2372 8.40911 21.3358 8.66511 21.3358C8.92111 21.3358 9.17711 21.2385 9.37178 21.0425L17.7051 12.7092C18.0958 12.3185 18.0958 11.6852 17.7051 11.2945L17.7064 11.2932Z"
      fill="currentColor"
    />
  </svg>
);
